module.exports = __webpack_public_path__ + "78f07e2c2a535c26ef21d95e41bd7175.woff";